<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h1 class="mat-headline-2" i18n>Cookie policy</h1>
        <h2><ng-container i18n>Last Updated</ng-container>: 27.02.2025</h2>
        
        <h3 i18n>1. Introduction</h3>
        <p i18n>
          Welcome to <a href="/">www.listx.ai</a> ("we," "us," or "our"). This Cookie Policy explains how we use cookies and similar tracking technologies
          on our website and platform. We use all the cookies and other web technologies, except the strictly necessary cookies, with your prior consent. 
          You always have the right to withdraw the consent in your browser settings.
        </p>
        
        <h3 i18n>2. What Are Cookies?</h3>
        <p i18n>
          Cookies are small text files that are placed on your device when you visit a website or use an application. 
          It is simply a technology for remembering something about you. 
        </p>
        
        <h3 i18n>3. Types of Cookies We Use and Why</h3>
        <p i18n>We set only first-party cookies, but we may also use third-party cookies provided by trusted partners, such as Google. 
        These cookies are used for various purposes, including analytics, advertising, and social media integration. 
        Please note that third parties may have their own cookie policies, and we do not have control over their use of cookies.</p>
        
        <p i18n>We may use both session cookies and persistent cookies. Session cookies or non-persistent cookies are cookies that exist only 
        temporarily while you browse our website. Your web browser should delete these cookies when you close your browser.
        However, persistent cookies expire on a specific date or after a period of time specified by the third party or us.</p>
        
        <p i18n>We use the following types of cookies:</p>
        <ul>
          <li i18n><b>Essential Cookies</b>: These cookies are necessary for the website to function properly. They enable basic functionalities such as page navigation, security, and access to certain areas of the website. The website cannot function properly without these cookies.</li>
          <li i18n><b>Analytical/Performance Cookies</b>: These cookies allow us to analyze how visitors use our website, which helps us improve its performance. These cookies collect information about traffic sources, popular pages, and user interactions on the website.</li>
          <li i18n><b>Functionality Cookies</b>: These cookies enable the website to remember choices you make and provide enhanced features. They may also be used to provide services you have requested.</li>
          <li i18n><b>Advertising/Targeting Cookies</b>: These cookies are used to deliver advertisements that are relevant to your interests. They may also be used to track the effectiveness of advertising campaigns. We may share this information with third parties for this purpose.</li>
        </ul>
        
        <p i18n>Hereunder we have listed all the cookies used on our website:</p>
        
        <h3 style="text-align: center" i18n>Essential</h3>
        <cookie-table [cookies]="cookies.essential"/>        
        
        <h3 style="text-align: center" i18n>Analytical/Performance</h3>
        <cookie-table [cookies]="cookies.analytical"/>  
        
        <h3 style="text-align: center" i18n>Functionality</h3>
        <cookie-table [cookies]="cookies.functional"/>  
        
        <h3 style="text-align: center" i18n>Advertising/Targeting</h3>
        <cookie-table [cookies]="cookies.advertising"/>  
        
        <h3 i18n>4. Managing Cookies</h3>
        <p i18n>You can control and manage cookies in various ways:<p>
        <ul>
          <li i18n>Most web browsers allow you to adjust your cookie settings. You can usually find these settings in your browser's "Options," "Settings," or "Preferences" menu.</li>
          <li i18n>You can opt out of certain third-party cookies by using online tools or by visiting the third-party websites directly.</li>
          <li i18n>To learn more about cookies and how to manage them, visit Cookie Consent Tools.</li>
        </ul>
        
        <h3 i18n>5. Changes to this Cookie Policy</h3>
        <p i18n>We may update this Cookie Policy to reflect changes in our practices or for other operational, legal, or regulatory reasons. 
        Please check this page regularly for updates.</p>
        
        <h3 i18n>6. Contact Us</h3>
        <p i18n>If you have any questions or concerns about this Cookie Policy, please contact us at support&#64;listx.ai.</p>
      </div>
    </div>
  </div>
</div>